console.log("Custom loading");

document.addEventListener("DOMContentLoaded", function() {
    const upsellDOM = document.querySelector('.bcc-upsell');

    if(typeof upsellDOM != 'undefined' && upsellDOM != null) {
        const atcBtns = upsellDOM.querySelectorAll('.upsell-atc');
        const atcArr = [];
        const upsellOptions = upsellDOM.querySelectorAll('.bcc-upsell-section form');
        const upsellOptionsArr = [];

        if(atcBtns.length > 0) {
            atcBtns.forEach(function(btn, index) {
                atcArr[index] = btn;

                atcArr[index].addEventListener("click", function(e) {
                    const textBtn = atcArr[index].querySelector('.btn-text');
                    atcArr[index].classList.add('loading');
                    atcArr[index].setAttribute('disabled', true);
                    
                    let formData = {
                        'items': [{
                            'id': atcArr[index].dataset.productId,
                            'quantity': 1
                        }]
                    };

                    fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(formData)
                    })
                    .then(response => {
                        return response.json();
                    })
                    .then(result => {
                        console.log(result);
                        atcArr[index].classList.remove('loading');
                        atcArr[index].removeAttribute('disabled');

                        theme.cart.getCart().then(function(cart) {
                            // Trigger the event that updates cart UI
                            $('body').trigger('added.ajaxProduct', atcArr[index]);
                        });
                    })
                    .catch((error) => {
                        atcArr[index].classList.remove('loading');
                        atcArr[index].removeAttribute('disabled');
                        textBtn.innerText = 'Error';
                        setTimeout(function() {
                            textBtn.innerText = 'Add';
                        }, 2000);
                        console.error('Error:', error);
                    });
                });
            });
        }

        if(upsellOptions.length > 0) {
            upsellOptions.forEach(function(formElm, index) {
                upsellOptionsArr[index] = formElm;

                upsellOptionsArr[index].addEventListener("change", function(e) {
                    const btn = this.querySelector('.upsell-atc');
                    const price = this.querySelector('.upsell-price');
                    const formData = new FormData(this);
                    const formValues = Array.from(formData.values());
                    const variantsJSON = JSON.parse(this.lastElementChild.innerText);
                    
                    const findVariant = variantsJSON.find((variant) => JSON.stringify(variant.options) == JSON.stringify(formValues));

                    if(typeof findVariant != 'undefined') {
                        console.log(findVariant);
                        const priceFormat = theme.Currency.formatMoney(findVariant.price);
                        price.innerText = priceFormat;
                        btn.dataset.productId = findVariant.id;
                        if(!findVariant.available) {
                            btn.setAttribute('disabled', true);
                            btn.innerText = 'Out of Stock';
                        } else if(btn.hasAttribute('disabled')) {
                            btn.innerText = 'Add';
                            btn.removeAttribute('disabled');
                        }
                    }
                    console.dir(formValues);
                    console.dir(variantsJSON);
                });
            });
        }
    }
});